/* ============ theme.js — interactions ported from the React app ============ */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var onReady = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------- Mobile nav ---------- */
  function initNav() {
    /* Delegated so the toggle works even if the header renders after this runs
       (direct listeners could miss the element on a slow/late first load). */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var nav = document.querySelector('[data-site-nav]');
      if (!nav) return;
      if (e.target.closest('[data-nav-toggle]')) {
        nav.classList.toggle('is-open');
        return;
      }
      if (nav.classList.contains('is-open') && e.target.closest('[data-site-nav] a')) {
        nav.classList.remove('is-open');
      }
    });
  }

  /* ---------- Header: light (cream + light logo) over hero, dark elsewhere/on scroll ---------- */
  function initHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var hero = document.getElementById('hero');
    var scrolled = false, heroInView = !!hero;

    function paint() {
      header.classList.toggle('is-light', !!hero && heroInView && !scrolled);
    }
    window.addEventListener('scroll', function () {
      scrolled = window.scrollY > 120; paint();
    }, { passive: true });

    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        heroInView = e[0].isIntersecting; paint();
      }, { threshold: 0.1 }).observe(hero);
    } else {
      heroInView = false;
    }
    paint();

    // profile dropdown
    var pBtn = header.querySelector('[data-profile-btn]');
    var pMenu = header.querySelector('[data-profile-menu]');
    if (pBtn && pMenu) {
      pBtn.addEventListener('click', function (e) { e.stopPropagation(); pMenu.classList.toggle('is-open'); });
      document.addEventListener('click', function (e) { if (!pMenu.contains(e.target) && e.target !== pBtn) pMenu.classList.remove('is-open'); });
    }
  }

  /* ---------- Generic scroll reveal (replaces the per-section IntersectionObservers) ---------- */
  function initReveals() {
    var els = document.querySelectorAll('[data-observe]');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) en.target.classList.add('is-visible');
        else en.target.classList.remove('is-visible');
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -100px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Swapping cards (rewrite of the Framer Motion SwappingCards.tsx) ----------
     Two stacked layers; current slides up & fades, next rises from +160px. 3.6s cycle. */
  function initSwap() {
    var root = document.querySelector('[data-swap]');
    if (!root) return;
    var layers = root.querySelectorAll('[data-swap-layer]');
    if (layers.length < 2) return;
    var cur = layers[0], nxt = layers[1];
    var count = parseInt(root.getAttribute('data-count'), 10) || 0;
    if (count < 2 || reduceMotion) return;

    function place(el, y, o, z) {
      el.style.transform = 'translateY(' + y + 'px)';
      el.style.opacity = o; el.style.zIndex = z;
    }
    place(cur, 0, 1, 30); place(nxt, 160, 0, 10);
    var idx = 0;

    setInterval(function () {
      nxt.style.zIndex = 20;
      place(cur, -60, 0, 30);
      place(nxt, 0, 1, 20);
      setTimeout(function () {
        // advance: the "next" becomes current; recycle the old node with the following item
        var tmp = cur; cur = nxt; nxt = tmp;
        idx = (idx + 1) % count;
        var nextItem = (idx + 1) % count;
        swapCardContent(nxt, nextItem);
        nxt.style.transition = 'none';
        place(nxt, 160, 0, 10);
        // force reflow then restore transition
        void nxt.offsetHeight;
        nxt.style.transition = '';
        cur.style.zIndex = 30;
      }, 600);
    }, 3600);

    function swapCardContent(layer, dataIndex) {
      var tpl = root.querySelector('[data-card-data="' + dataIndex + '"]');
      if (tpl) layer.querySelector('[data-card-mount]').innerHTML = tpl.innerHTML;
    }
  }

  /* ---------- Signature carousel (ported from SignatureCoffee.tsx index math) ---------- */
  function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var cards = track ? track.children : [];
      if (!track || cards.length === 0) return;

      function perView() {
        var w = window.innerWidth;
        if (w >= 1024) return 4; if (w >= 768) return 3; return 2;
      }
      var index = 0;
      function maxIndex() { return Math.max(0, cards.length - perView()); }
      function render() {
        if (index > maxIndex()) index = maxIndex();
        var card = cards[0];
        var step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(card).marginRight || 0);
        track.style.transform = 'translateX(' + (-index * step) + 'px)';
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index >= maxIndex();
      }
      if (prev) prev.addEventListener('click', function () { index = Math.max(0, index - 1); render(); });
      if (next) next.addEventListener('click', function () { index = Math.min(maxIndex(), index + 1); render(); });
      window.addEventListener('resize', render);
      render();
    });
  }

  /* ---------- Duplicate marquee content so the -50% keyframe loops seamlessly ---------- */
  function initMarquee() {
    document.querySelectorAll('[data-marquee-row]').forEach(function (row) {
      row.innerHTML = row.innerHTML + row.innerHTML;
    });
  }

  /* ---------- AJAX add to cart + live count ---------- */
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.style.display = c.item_count > 0 ? 'flex' : 'none';
      });
    }).catch(function () {});
  }
  function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var item = { id: id, quantity: 1 };
      var w = btn.getAttribute('data-variant-weight');
      if (w) item.properties = { 'Weight': w };
      btn.style.opacity = '.6';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) { return r.json(); })
        .then(function () { refreshCount(); btn.style.opacity = '1'; })
        .catch(function () { btn.style.opacity = '1'; });
    });
  }

  /* ---------- Newsletter (Roasted section) -> Shopify customer form fallback handled in Liquid ---------- */

  onReady(function () {
    initNav(); initHeader(); initReveals();
    initSwap(); initCarousel();
    initMarquee(); initAddToCart(); refreshCount();
  });
})();